import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import OtpInput from "react-otp-input";
import Button from "react-bootstrap/Button";
import { ButtonWrapper, ModalBody } from "./Style";
import "../contact/ContactHome.css";
//===================================================================

//otp Box Design
export function OtpBox({ show, onHide, otp, setOtp, handleClick, onSignUp, phone, isLoading, attempts = 2 }) {
  const [timer, setTimer] = useState(30);
  const [counter, setCounter] = useState(attempts);

  useEffect(() => {
    let intervalId;

    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

   useEffect(() => {
      if (!show) {
        setOtp("");
        setTimer(30);
        setCounter(attempts);
      }
    }, [show]);

  const handleChange = (otp) => setOtp(otp);

  // function handleCloseBox() {
  //   setOtpBox(false);
  // }

  const handleResendOtp = (e) => {
    setTimer(30);
    setCounter(prevCounter => prevCounter - 1);
    handleClick(e);
    setOtp("");
  }

  return (
    <>
      <Modal
        className="my-modal1"
        size="lg"
        id="otp-box"
        onHide={onHide}
        show={show}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName="otp_card"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-center"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalBody>
            <h2 style={{ textAlign: "center" }}>OTP Verification</h2>
            <p style={{ fontFamily: "Poppins", textAlign: "center" }}>
              Please enter the One-Time Code to verify your account.
              <br />A One-time code has been sent to {phone}
            </p>
            <h2>
              <OtpInput
                inputStyle={{
                  border: "none",
                  borderBottom: "2px solid grey",
                  outline: "none",
                }}
                className="otp_input"
                inputType="tel"
                value={otp}
                onChange={handleChange}
                numInputs={6}
                separator={<span>&ensp;</span>}
                renderInput={(props) => <input {...props} />}
              />
            </h2>
            <ButtonWrapper
              onClick={onSignUp}
              disabled={otp.length !== 6 || isLoading}
            >
              {isLoading ? 'Verifying...' : 'Verify'}
            </ButtonWrapper>
            <>
              {counter > 0 &&
                <button
                  className="btn btn-link"
                  onClick={handleResendOtp}
                  disabled={timer > 0}
                >
                  Resend one-Time Code {" "}
                  {timer > 0 && <span>00:{timer}</span>}
                </button>
              }
              {counter > 0 && <h6>({counter} Attempt left)</h6>}
              {counter <= 0 && <h6 style={{ color: "red", marginTop: "5px" }}>No attempt left! Please try again after 10 mins.</h6>}
            </>
          </ModalBody>
        </Modal.Body>
      </Modal>
    </>
  );
}


function XDevOtpBox({ onHide, otp, setOtp, phone, show, setOtpBox, isEmailExist, handleClick }) {

  const handleChange = (otp) => {
    setOtp(otp);
  };

  // function handleCloseBox() {
  //   setOtpBox(false);
  // }
  return (
    <>
      <Modal
        className="my-modal1"
        id="modal1"
        size="lg"
        show={show}
        backdrop="static"
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalBody>
            <h2 style={{ textAlign: "center" }}>OTP Verification</h2>
            <p style={{ fontFamily: "Poppins", textAlign: "center" }}>
              Please enter the one-Time Code to verify your account.
              <br />A one-Time code has been sent to {phone}
            </p>
            <OtpInput
              className="otp_input"
              inputType="tel"
              value={otp}
              onChange={handleChange}
              numInputs={6}
              separator={<span>&ensp;</span>}
              renderInput={(props) => <input {...props} />}
              inputStyle={{
                border: "none",
                borderBottom: "2px solid grey",
                outline: "none",
              }}
            />
          </ModalBody>
        </Modal.Body>

        <Modal.Footer
          className="modal-footer"
          style={{
            "--bs-modal-footer-border-color": "white",
            "--bs-modal-footer-gap": "0",
            paddingBottom: "30px",
            fontFamily: "Poppins",
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <Button
              style={{
                display: "flex",
                justifyContent: "center",
                borderredius: "20px",
                alignItems: "center",
                fontWeight: "bold",
                width: "100%",
                height: "7%",
              }}
              onClick={() => isEmailExist()}
              className="text-center"
              disabled={otp.length < 6}
            >
              Verify
            </Button>
            <div>
              <button
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textDecorationLine: "none",
                }}
                className="btn btn-link"
                onClick={handleClick}
              >
                Resend one-Time Code
              </button>
              {/* <p
                // onClick={handleCloseBox}
                style={{ fontSize: "medium", cursor: "pointer" }}
              >
                Entered a wrong Number?
              </p> */}
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}